import React from "react";
import "./LoaderLogo.css";
import Typewriter from "typewriter-effect";
import { PropagateLoader } from "react-spinners";

function Type() {
  return (
    <Typewriter
      options={{
        strings: ["Daniel Constante"],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

const LogoLoader = (props) => {
  const theme = props.theme;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center", // Added to center horizontally
        gap: "20px", // Consistent spacing between text and dots
      }}
    >
      <h1 style={{ color: "#fff", fontFamily: "Inter", margin: 0 }}>
        <Type style={{ color: theme.text }} />
      </h1>
      <PropagateLoader
        color= "#fff"// Fixed: Use theme.text with fallback to white
        size={16} // Slightly larger for visibility
        speedMultiplier={0.8} // Smoother, slower wave effect
        aria-label="Loading dots"
      />
    </div>
  );
};

export default LogoLoader;